import { CountryReducerState, CountryItem } from './types'
import { uniqueId } from 'lodash'

export const GET_COUNTRIES = uniqueId('GET_COUNTRIES')
export const GET_COUNTRIES_SUCCESS = uniqueId('GET_COUNTRIES_SUCCESS')
export const GET_COUNTRIES_FAILURE = uniqueId('GET_COUNTRIES_FAILURE')

const INITIAL_STATE: CountryReducerState = {
  countryListLoading: true,
  countryList: [],
  countryListFailedMessage: undefined
}

export const countryReducer = (
  state: CountryReducerState = INITIAL_STATE,
  action: {
    type: string
    countryList: CountryItem[]
    countryListFailedMessage?: string
  }
): CountryReducerState => {
  const { type, countryList, countryListFailedMessage } = action
  switch (type) {
    case GET_COUNTRIES:
      return { ...state, ...INITIAL_STATE, countryListLoading: true }
    case GET_COUNTRIES_FAILURE:
      return { ...state, countryListLoading: false, countryListFailedMessage }
    case GET_COUNTRIES_SUCCESS:
      return { ...state, countryListLoading: false, countryList }
    default:
      return state
  }
}
